<template >
  <div class="msstatus global__scrollbar">
    <div class="" v-if="detail">
      <div class="msstatus__tracking">
        <p class="msstatus__tracking--title mb-3">SHIPMENT TRACKING STATUS</p>
        <div class="row justify-content-center msstatus__tracking--icon" v-if="isLoadingOtif">
          <b-spinner variant="secondary"></b-spinner>
        </div>
        <div v-else>
          <div class="row m-0 msstatus__tracking--icon mb-1">
            <div class="col-md p-0 text-center _relativeblock"
            v-for="(item, i) in otifList" :key="i">
              <img :id="`tooltip-${i}`" :style="getOtifColor(item.filterColor)"
              :src="item.imageOtif" alt="">
              <img class="_bullet" :style="getOtifColor(item.filterColor === 'red' ? 'blue'
              : item.filterColor)" src="@/assets/image/icon/bullet_line3.png" alt=""
              v-if="item.otifName !== 'BOOKED'">
              <b-tooltip :target="`tooltip-${i}`" id="tooltipTrackingStatus" placement="bottomright">
                <div class="tooltiptext text-left" v-if="item.content.length > 0">
                  <div class="row m-0" v-for="(otifContent, contentIndex) in item.content"
                  :key="contentIndex">
                    <p class="col-md-6 p-0">{{otifContent.title}}</p>
                    <p class="col-md p-0">: {{otifContent.data}} </p>
                  </div>
                </div>
              </b-tooltip>
            </div>
          </div>
          <div class="row m-0 msstatus__tracking--text">
            <div class="col-md p-0 text-center" v-for="(item, i) in otifList" :key="i">
              <p :class="getOtifTextColor(item.filterColor)">{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md msstatus__additional mb-3"
      v-if="(this.detail.orderStat === 'REJECTED') ||
      (this.detail.orderStat === 'CANCELLED') || (this.detail.orderStat === 'COMPLETED_OTIF')">
        <div class="msstatus__additional--title mb-1"
        :class="this.detail.orderStat === 'COMPLETED_OTIF' ?
        'titleGreen' : 'titleRed'" >{{boxTitle}}</div>
        <div class="msstatus__additional--content">{{boxContent}}</div>
        <div class="msstatus__additional--content">{{boxReason}}</div>
        <div class="msstatus__additional--content mt-3" v-if="boxInfo">{{boxInfo}}</div>
      </div>
      <div class="msstatus__tracking" v-if="(this.detail.orderStat !== 'CANCELLED') &&
      (this.detail.orderStat !== 'REJECTED') && getDelayLog && getDelayLog.length > 0">
        <p class="msstatus__tracking--title mb-2">DELAY LOG</p>
        <div class="row m-0">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" v-for="(item, i) in delayList.header" :key="i">
                  {{item}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr  v-for="(item, i) in getDelayLog" :key="i">
                <td style="width: 12%" class="pl-0">{{item.dateFrom}}</td>
                <td style="width: 15%" class="pl-0">{{getShipmentStatus(item.status)}}</td>
                <td style="width: 12%" class="pl-0">{{item.dateTo}}</td>
                <td class="pl-0">{{item.note}}</td>
                <td class="pl-0">{{item.attachmentStat ? `${item.fileCategory}${item.fileExt}` : '-'}}</td>
                <td class="pl-0" v-if="item.attachmentStat">
                  <!-- <b-spinner small variant="secondary" v-if="idDelayLogSelected && isDownloading"></b-spinner> -->
                  <img @click="downloadDelayFile(item)" src="@/assets/image/icon/download-docs.svg" alt="">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="msstatus__tracking px-0">
        <p class="msstatus__tracking--title mb-2" style="padding-left: 14px">TRACKING LOG</p>
        <table class="table__tracking">
          <thead>
            <tr>
              <th :class="detail && detail.freightMode === 'AIR' ?
              'global__bc_purple' : detail && detail.freightMode === 'OCEAN' ?
              'global__bc_blue' : detail && detail.freightMode === 'LAND' ?
              'global__bc_deepgreen' : 'global__bc_darkgray'" scope="col" :width="item.width" v-for="(item, i) in trackingList.header" :key="i">
                {{item.title}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr  v-for="(item, i) in trackingList.body" :key="i">
              <td>{{item.date}}</td>
              <td>{{item.status}}</td>
              <td>
                <div class="row m-0" v-for="(detail, y) in item.details" :key="y">
                  <div class="col-md-5 p-0">{{detail.label}}</div>
                  <div class="pr-2">:</div>
                  <div class="col-md p-0">{{detail.value}}</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="msstatus__tracking" v-if="(this.detail.orderStat !== 'CANCELLED') &&
      (this.detail.orderStat !== 'REJECTED') && getDelayLog && getDelayLog.length < 1">
        <p class="msstatus__tracking--title mb-2">DELAY LOG</p>
        <div class="row m-0 no_delay">
          Yay!! There is no delay in your shipment so far.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from '@/mixin/getters/shipment-details'
import * as consts from '@/constant/shipment-details'
import dateTime from '@/mixin/getters/date-time'
import moment from 'moment'

export default {
  name: 'ShipmentTrackingAirOcean',
  data () {
    return {
      today: moment().format('YYYY-MM-DD'),
      format: 'DD/MM/YY',
      import: true, // true or false edit
      shipmentId: this.$route.params.id_shipment,
      orderNumber: this.$route.params.order_number,
      otifList: [],
      trackingList: {
        header: [{ title: 'Update Date', width: '15%' }, { title: 'Status', width: '30%' }, { title: 'Details', width: '55%' }]
      },
      delayList: {
        header: ['Delay Date', 'Status', 'E. Delay Until', 'Delay Note', 'Attachment'],
        body: []
      },
      otifs: {
        scheduled: '',
        pickup: '',
        trackingNumber: '',
        OL: '',
        departure: '',
        arrival: '',
        DL: '',
        delivery: '',
        completed: '',
        delay: ''
      },
      reasonRejected: '',
      reasonCancelled: '',
      boxTitle: '',
      boxContent: '',
      boxReason: '',
      boxInfo: '',
      idDelayLogSelected: ''
    }
  },
  mixins: [mixin, dateTime],
  computed: {
    ...mapGetters({
      // shipment
      detail: 'shipment/item',
      isLoadingDetail: 'shipment/isLoading',
      isError: 'shipment/error',
      // otif
      otif: 'shipment/otif',
      isLoadingOtif: 'shipment/otifIsLoading',
      isErrorOtif: 'shipment/errorOtif',
      // delay log
      getDelayLog: 'shipment/getDelayLog',
      isLoadingGetDelayLog: 'shipment/isLoadingGetDelayLog',
      isErrorGetDelayLog: 'shipment/isErrorGetDelayLog',

      isDownloading: 'shipment/isDownloading'
    })
  },
  mounted () {
    this.fetchShipmentDetail()
  },
  methods: {
    resetData () {
      this.reasonRejected = ''
      this.reasonCancelled = ''
    },
    getOtifTextColor (type) {
      let nameClass = ''
      if (type === 'red') {
        nameClass = 'color_red'
      }
      if (type === 'green') {
        nameClass = 'color_green'
      }
      if (type === 'blue') {
        nameClass = 'color_blue'
      }
      if (type === 'grey') {
        nameClass = 'color_grey'
      }
      return nameClass
    },
    downloadDelayFile (item) {
      this.idDelayLogSelected = item.idFile
      const fileName = `DelayProof-${item.fileCategory}${item.fileExt}`
      const type = 'shipment'
      this.$store.dispatch('shipment/DOWNLOAD_SHIPMENT_DOCUMENT', {
        shipmentId: this.shipmentId,
        orderNumber: this.orderNumber,
        type,
        fileName,
        fileId: item.idFile,
        fileCategory: item.fileCategory
      })
    },
    createOtifList (data) {
      this.otifList = []
      const shimentService = data.shipment_service
      const isRejected = data.orderStat === consts.OTIF_REJECTED
      const isCanceled = data.orderStat === consts.OTIF_CANCELED

      const { freightMode } = data
      const booked = {
        name: 'Booked',
        otifName: consts.OTIF_BOOKED,
        imageOtif: this.getImageOtif(consts.OTIF_BOOKED, freightMode)
      }
      const scheduled = {
        name: 'Scheduled',
        otifName: consts.OTIF_SCHEDULED,
        imageOtif: this.getImageOtif(consts.OTIF_SCHEDULED, freightMode)
      }
      const pickup = {
        name: 'Pickup',
        otifName: consts.OTIF_PICKUP,
        imageOtif: this.getImageOtif(consts.OTIF_PICKUP, freightMode)
      }
      const olc = {
        name: 'Origin Local Handling',
        otifName: consts.OTIF_OLC,
        imageOtif: this.getImageOtif(consts.OTIF_OLC, freightMode)
      }
      const departure = {
        name: 'Departure',
        otifName: consts.OTIF_DEPARTURE,
        imageOtif: this.getImageOtif(consts.OTIF_DEPARTURE, freightMode)
      }
      const arrival = {
        name: 'Arrival',
        otifName: consts.OTIF_ARRIVAL,
        imageOtif: this.getImageOtif(consts.OTIF_ARRIVAL, freightMode)
      }
      const dlc = {
        name: 'Destination Local Handling',
        otifName: consts.OTIF_DLC,
        imageOtif: this.getImageOtif(consts.OTIF_DLC, freightMode)
      }
      const delivery = {
        name: 'Delivery',
        otifName: consts.OTIF_DELIVERY,
        imageOtif: this.getImageOtif(consts.OTIF_DELIVERY, freightMode)
      }
      const completed = {
        name: 'Completed',
        otifName: consts.OTIF_COMPLETED,
        imageOtif: this.getImageOtif(consts.OTIF_COMPLETED, freightMode)
      }
      // truck management system
      if (shimentService === consts.SERVICE_PORT_TO_PORT) {
        this.otifList.push(booked, scheduled, departure, arrival, completed)
      }
      if (shimentService === consts.SERVICE_PORT_TO_DOOR) {
        this.otifList.push(booked, scheduled, departure, arrival, dlc, delivery, completed)
      }
      if (shimentService === consts.SERVICE_DOOR_TO_PORT) {
        this.otifList.push(booked, scheduled, pickup, olc, departure, arrival, completed)
      }
      if (shimentService === consts.SERVICE_DOOR_TO_DOOR) {
        this.otifList.push(booked, scheduled, pickup, olc, departure,
          arrival, dlc, delivery, completed)
      }
      this.otifList.forEach((item, i) => {
        if (item.name === 'Booked') {
          this.otifList[i] = Object.assign(item, { filterColor: isRejected || isCanceled ? 'red' : 'blue' }, { content: [] })
        } else {
          this.otifList[i] = Object.assign(item, { filterColor: 'grey' }, { content: [] })
        }
      })
    },
    async fetchShipmentDetail () {
      await this.$store.dispatch('shipment/FETCH_SHIPMENT_DETAIL', { shipmentId: this.shipmentId, orderNumber: this.orderNumber })
    },
    async fetchShipmentOtifDetail () {
      await this.$store.dispatch('shipment/FETCH_OTIF', { shipmentId: this.shipmentId, orderNumber: this.orderNumber })
    },
    async fetchDelayLog () {
      await this.$store.dispatch('shipment/GET_DELAY_LOG', { shipmentId: this.shipmentId, orderNumber: this.orderNumber })
    },
    getOtifContent (data) {
      const isCompleted = this.detail.orderStat === consts.OTIF_COMPLETED
      const isRejected = this.detail.orderStat === consts.OTIF_REJECTED
      const isCanceled = this.detail.orderStat === consts.OTIF_CANCELED

      data.forEach((content) => {
        const isDelayed = content.delay && content.delay.length > 0
        this.otifList.forEach((list, i) => {
          if (list.otifName === consts.OTIF_BOOKED) {
            // eslint-disable-next-line no-nested-ternary
            this.otifList[i].filterColor = isCompleted ? 'green' : (isRejected || isCanceled) ? 'red' : 'blue'
          }
          if (content.otif_stat === list.otifName) {
            this.otifList[i].content = []
            // eslint-disable-next-line no-nested-ternary
            this.otifList[i].filterColor = isCompleted ? 'green' : isDelayed ? 'red' : 'blue'
            if (content.otif_stat === consts.OTIF_SCHEDULED) {
              this.otifList[i].content.push(
                { title: 'Estimate Pickup Date', data: this.getDateDefauld(content.estimate_pickup_date) },
                { title: 'ETD', data: this.getDateDefauld(content.etd) },
                { title: 'ETA', data: this.getDateDefauld(content.eta) }
              )
            }
            if (content.otif_stat === consts.OTIF_PICKUP) {
              if (this.detail.bookType === 'import') {
                this.otifList[i].content.push(
                  { title: 'Pick Up Date', data: this.getDateDefauld(content.date) }
                )
              } else {
                this.otifList[i].content.push(
                  { title: 'Pick Up Date', data: this.getDateDefauld(content.date) },
                  { title: 'Pick Up Time', data: content.pickup_delivery_time },
                  { title: 'Driver Name', data: content.driver_name },
                  { title: "Driver's Phone Number", data: content.driver_phone_number },
                  { title: "Vehicle's Plate Number", data: content.vehicle_plate_number }
                )
              }
            }
            if (content.otif_stat === consts.OTIF_OLC) {
              this.otifList[i].content.push(
                { title: 'Origin Local Handling', data: this.getDateDefauld(content.date) }
              )
            }
            if (content.otif_stat === consts.OTIF_DEPARTURE) {
              this.otifList[i].content.push(
                { title: 'Departure', data: this.getDateDefauld(content.date) }
              )
            }
            if (content.otif_stat === consts.OTIF_ARRIVAL) {
              this.otifList[i].content.push(
                { title: 'Arival', data: this.getDateDefauld(content.date) }
              )
            }
            if (content.otif_stat === consts.OTIF_DLC) {
              this.otifList[i].content.push(
                { title: 'Destination Local Handling', data: this.getDateDefauld(content.date) }
              )
            }
            if (content.otif_stat === consts.OTIF_DELIVERY) {
              this.otifList[i].content.push(
                { title: 'Delivery', data: this.getDateDefauld(content.date) }
              )
              if (this.detail.bookType === 'import') {
                this.otifList[i].content.push(
                  { title: 'Delivery Time', data: content.pickup_delivery_time },
                  { title: 'Driver Name', data: content.driver_name },
                  { title: "Driver's Phone Number", data: content.driver_phone_number },
                  { title: "Vehicle's Plate Number", data: content.vehicle_plate_number }
                )
              }
            }
            if (content.otif_stat === consts.OTIF_COMPLETED) {
              this.otifList[i].content.push(
                { title: 'Completed', data: this.getDateDefauld(content.date) }
              )
            }
          }
        })
      })
    },

    getOtif (data) {
      this.trackingList.body = [
        { date: this.getDateFormat1(this.detail.createdAt), status: 'Booked', details: [{label: '-', value: '-'}] }
      ]
      data.forEach((item) => {
        if (item.otif_stat === 'SCHEDULED_OTIF') {
          this.trackingList.body.push(
            {
              date: this.getDateFormat1(item.created_at),
              status: 'Scheduled',
              details: [
                { label: 'Estimate Pickup Date', value: this.getDateFormat1(item.estimate_pickup_date) },
                { label: 'ETD', value: this.getDateFormat1(item.etd) },
                { label: 'ETA', value: this.getDateFormat1(item.eta) }
              ]
            }
          )
        }
        if (item.otif_stat === 'PICKUP') {
          if (this.detail.bookType === 'import') {
            this.trackingList.body.push(
              {
                date: this.getDateFormat1(item.created_at),
                status: 'Pickup',
                details: [
                  { label: 'Pick Up Date', value: this.getDateFormat1(item.date) },
                  { label: 'Location', value: item.location },
                  { label: 'Activity', value: item.note }
                ]
              }
            )
          } else {
            this.trackingList.body.push(
              {
                date: this.getDateFormat1(item.created_at),
                status: 'Pickup',
                details: [
                  { label: 'Pick Up Date', value: this.getDateFormat1(item.date) },
                  { label: 'Pick Up Time', value: this.getTime12(item.pickup_delivery_time) },
                  { label: 'Driver Name', value: item.driver_name },
                  { label: "Driver's Phone Number", value: item.driver_phone_number },
                  { label: "Vehicle's Plate Number", value: item.vehicle_plate_number },
                  { label: 'Location', value: item.location },
                  { label: 'Activity', value: item.note }
                ]
              }
            )
          }
        }
        if (item.otif_stat === 'ORIGIN_LOCAL_HANDLING') {
          this.trackingList.body.push(
            {
              date: this.getDateFormat1(item.created_at),
              status: 'Origin Local Handling',
              details: [
                { label: 'Origin Local Handling', value: this.getDateFormat1(item.date) },
                { label: 'Location', value: item.location },
                { label: 'Activity', value: item.note }
              ]
            }
          )
        }
        if (item.otif_stat === 'DEPARTURE') {
          this.trackingList.body.push(
            {
              date: this.getDateFormat1(item.created_at),
              status: 'Departure',
              details: [
                { label: 'Departure', value: this.getDateFormat1(item.date) },
                { label: 'Location', value: item.location },
                { label: 'Activity', value: item.note }
              ]
            }
          )
        }
        if (item.otif_stat === 'ARRIVAL') {
          this.trackingList.body.push(
            {
              date: this.getDateFormat1(item.created_at),
              status: 'Arrival',
              details: [
                { label: 'Arrival', value: this.getDateFormat1(item.date) },
                { label: 'Location', value: item.location },
                { label: 'Activity', value: item.note }
              ]
            }
          )
        }
        if (item.otif_stat === 'DESTINATION_LOCAL_HANDLING') {
          this.trackingList.body.push(
            {
              date: this.getDateFormat1(item.created_at),
              status: 'Destination Local Handling',
              details: [
                { label: 'Destination Local Handling', value: this.getDateFormat1(item.date) },
                { label: 'Location', value: item.location },
                { label: 'Activity', value: item.note }
              ]
            }
          )
        }
        if (item.otif_stat === 'DELIVERY') {
          const detailImport = [
            { label: 'Delivery', value: this.getDateFormat1(item.date) },
            { label: 'Delivery Time', value: this.getTime12(item.pickup_delivery_time) },
            { label: 'Driver Name', value: item.driver_name },
            { label: "Driver's Phone Number", value: item.driver_phone_number },
            { label: "Vehicle's Plate Number", value: item.vehicle_plate_number },
            { label: 'Location', value: item.location },
            { label: 'Activity', value: item.note }
          ]
          const detailExport = [
            { label: 'Delivery', value: this.getDateFormat1(item.date) },
            { label: 'Location', value: item.location },
            { label: 'Activity', value: item.note }
          ]
          this.trackingList.body.push(
            {
              date: this.getDateFormat1(item.created_at),
              status: 'Delivery',
              details: this.detail.bookType === 'import' ? detailImport : detailExport
            }
          )
        }
        if (item.otif_stat === 'COMPLETED_OTIF') {
          this.trackingList.body.push(
            {
              date: this.getDateFormat1(item.created_at),
              status: 'Completed',
              details: [
                { label: 'Completed', value: this.getDateFormat1(item.date) },
                { label: 'Location', value: item.location },
                { label: 'Activity', value: item.note }
              ]
            }
          )
        }
      })
    },
    getTime (date) {
      if (date) {
        const date1 = date.replace('T', ' ')
        const date2 = date1.replace(':00.000Z', '')
        return moment(date2).format('HH:mm')
      }
    },
    getShipmentStatus (item) {
      let status = ''
      if (item === 'SCHEDULED_OTIF') { status = 'Scheduled' }
      if (item === 'PICKUP') { status = 'Pickup' }
      if (item === 'ORIGIN_LOCAL_HANDLING') { status = 'Origin Local Handling' }
      if (item === 'DEPARTURE') { status = 'Departure' }
      if (item === 'ARRIVAL') { status = 'Arrival' }
      if (item === 'DESTINATION_LOCAL_HANDLING') { status = 'Destination Local Handling' }
      if (item === 'DELIVERY') { status = 'Delivery' }
      if (item === 'COMPLETED_OTIF') { status = 'Completed' }
      if (item === 'DELAY') { status = 'Delay' }
      return status
    }
  },
  watch: {
    otif (data) {
      if (data) {
        this.getOtif(data)
        this.getOtifContent(data)
      }
    },
    detail (data) {
      if (data) {
        this.reasonRejected = data.orderStat === 'REJECTED' ? data.orderStatNote : ''
        this.reasonCancelled = data.orderStat === 'CANCELLED' ? data.orderStatNote : ''

        const isCompleted = this.detail.orderStat === consts.OTIF_COMPLETED
        const isRejected = this.detail.orderStat === consts.OTIF_REJECTED
        const isCanceled = this.detail.orderStat === consts.OTIF_CANCELED

        if (isCompleted) {
          this.boxTitle = 'Shipment Completed'
          this.boxContent = 'Congratulation!! This shipment has been completed. Please go to payment section to process your shipment invoices.'
          this.boxReason = ''
          this.boxInfo = ''
        }
        if (isRejected || isCanceled) {
          this.boxTitle = isRejected ? 'Rejected Shipment' : 'Canceled Shipment'
          this.boxContent = `Unfortunately this shipment has been ${isRejected ? 'Rejected' : 'Canceled'} by the customer for reason as bellow : `
          this.boxReason = this.detail.orderStatNote
          this.boxInfo = isRejected ? 'We are sorry for this inconvenience' : 'If you change your mind please contact us or create a new shipment by clicking the shipment button'
        }
        if (data && data.freights) {
          this.createOtifList(data)
          this.fetchShipmentOtifDetail()
          this.fetchDelayLog()
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/ShipmentTrackingAirOcean.vue